import { useTranslation } from "react-i18next";
import { PlusIcon } from "@radix-ui/react-icons";
import { Button } from "@libs/zapi-ui/ds/components/button";
import { LeoWordmark } from "@libs/zapi-ui/ds/components/leo-wordmark";
import { ChatShell } from "@/zapi-frontend/shared/ui/chat";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";
import { hasEditAccess } from "@/zapi-frontend/shared/utils/permissions";

// Leo has no Add files button, so it is shown only while a regular chat is expected.
export function ChatPanelLoading({ leo = false }: { leo?: boolean }) {
  const { t } = useTranslation(["common", "projectHome"]);
  const { role, accessMode } = useMeStore();
  const title = leo ? t("projectHome:leo.title") : t("projectHome:chat.title");
  return (
    <ChatShell
      appearance="leo"
      className="h-full w-full"
      bodyClassName="p-0 overflow-hidden"
      data-testid="chat-panel-loading"
      title={title}
      titleMark={leo ? <LeoWordmark className="h-[15px] w-auto text-leo" title={title} /> : undefined}
      placeholder={leo ? t("projectHome:leo.placeholderAnything") : t("loadingChapter")}
      input=""
      onInputChange={() => undefined}
      onSubmit={() => undefined}
      isLoading
      loadingLabel={t("loadingMessages")}
      controlsLeft={
        !leo && hasEditAccess(role, accessMode) ? (
          <Button variant="secondary" size="sm" type="button" disabled>
            <PlusIcon /> {t("addFiles")}
          </Button>
        ) : undefined
      }
      onClear={() => undefined}
      canClear={false}
      clearConfirm={{ menuLabel: t("clear") }}
      dockCloseLabel={leo ? t("projectHome:leo.hide") : t("projectHome:chat.hide")}
    />
  );
}
